var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "perfil" } },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-3 col-xs-12" },
          [
            _c("b-card", { staticClass: "p-2 card-top" }, [
              _c(
                "div",
                { attrs: { id: "card-info" } },
                [
                  _c("b-card-body", [
                    _c(
                      "div",
                      { staticClass: "text-center" },
                      [
                        _c("vs-avatar", {
                          staticClass: "border-2 border-solid border-white",
                          attrs: {
                            id: "avatar",
                            src: _vm.currentUser.avatar,
                            size: "100px"
                          },
                          on: { click: _vm.abrirPrompAvatar }
                        }),
                        _vm.progressAvatar.enabled
                          ? _c("vs-progress", {
                              attrs: {
                                percent: _vm.progressAvatar.percent,
                                indeterminate: _vm.progressAvatar.indeterminate
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c("div", { staticClass: "text-center" }, [
                      _c("h4", { attrs: { id: "alias-usuario-actual" } }, [
                        _vm._v(_vm._s(_vm.currentUser.alias))
                      ]),
                      _c(
                        "p",
                        {
                          staticClass: "text-grey",
                          attrs: { id: "nombre-usuario-actual" }
                        },
                        [_vm._v("(" + _vm._s(_vm.currentUser.nombre) + ")")]
                      ),
                      _c(
                        "p",
                        {
                          staticClass: "text-grey",
                          attrs: { id: "correo-usuario-actual" }
                        },
                        [_vm._v(_vm._s(_vm.currentUser.correo))]
                      ),
                      _c(
                        "p",
                        {
                          staticClass: "text-grey",
                          attrs: { id: "iut-usuario-actual" }
                        },
                        [_vm._v(_vm._s(_vm.currentUser.iut))]
                      )
                    ])
                  ]),
                  _c("div")
                ],
                1
              )
            ])
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-6 col-xs-12" },
          [
            _c(
              "b-card",
              { staticClass: "card-top", attrs: { title: "Editar perfil" } },
              [
                _c("form", { attrs: { id: "editar-perfil" } }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-6 col-xs-12" },
                      [
                        _c(
                          "label",
                          { staticClass: "lbl", attrs: { for: "iut" } },
                          [_vm._v("Rut")]
                        ),
                        _c("vs-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          staticClass: "w-full",
                          attrs: {
                            id: "iut",
                            name: "iut",
                            "icon-pack": "material-icons",
                            icon: "fingerprint",
                            "icon-no-border": "",
                            value: _vm.actualUserInfo.iut,
                            disabled: true
                          }
                        }),
                        _c("span", { staticClass: "text-danger text-sm" }, [
                          _vm._v(_vm._s(_vm.errors.first("iut")))
                        ])
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6 col-xs-12" },
                      [
                        _c("vs-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required|min:5|max:50",
                              expression: "'required|min:5|max:50'"
                            }
                          ],
                          staticClass: "w-full",
                          attrs: {
                            name: "nombre",
                            "icon-pack": "material-icons",
                            icon: "account_circle",
                            "icon-no-border": "",
                            label: "Nombre",
                            value: _vm.actualUserInfo.nombre
                          },
                          on: {
                            input: function($event) {
                              return _vm.updateUserInfoData("nombre", $event)
                            }
                          }
                        }),
                        _c("span", { staticClass: "text-danger text-sm" }, [
                          _vm._v(_vm._s(_vm.errors.first("nombre")))
                        ])
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-6 col-xs-12" },
                      [
                        _c("vs-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required|min:3|max:50",
                              expression: "'required|min:3|max:50'"
                            }
                          ],
                          staticClass: "w-full",
                          attrs: {
                            name: "alias",
                            "icon-pack": "material-icons",
                            icon: "favorite",
                            "icon-no-border": "",
                            label: "Alias",
                            value: _vm.actualUserInfo.alias
                          },
                          on: {
                            input: function($event) {
                              return _vm.updateUserInfoData("alias", $event)
                            }
                          }
                        }),
                        _c("span", { staticClass: "text-danger text-sm" }, [
                          _vm._v(_vm._s(_vm.errors.first("alias")))
                        ])
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6 col-xs-12" },
                      [
                        _c("vs-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required|email|min:10|max:150",
                              expression: "'required|email|min:10|max:150'"
                            }
                          ],
                          staticClass: "w-full",
                          attrs: {
                            type: "email",
                            name: "correo",
                            "icon-pack": "material-icons",
                            icon: "email",
                            "icon-no-border": "",
                            label: "Correo",
                            value: _vm.actualUserInfo.correo
                          },
                          on: {
                            input: function($event) {
                              return _vm.updateUserInfoData("correo", $event)
                            }
                          }
                        }),
                        _c("span", { staticClass: "text-danger text-sm" }, [
                          _vm._v(_vm._s(_vm.errors.first("correo")))
                        ])
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6 col-xs-12" },
                      [
                        _c("vs-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required|min:1|max:100",
                              expression: "'required|min:1|max:100'"
                            }
                          ],
                          staticClass: "w-full",
                          attrs: {
                            type: "email",
                            name: "correo",
                            "icon-pack": "material-icons",
                            icon: "email",
                            "icon-no-border": "",
                            label: "Departamento",
                            value: _vm.actualUserInfo.departamento
                          },
                          on: {
                            input: function($event) {
                              return _vm.updateUserInfoData(
                                "departamento",
                                $event
                              )
                            }
                          }
                        }),
                        _c("span", { staticClass: "text-danger text-sm" }, [
                          _vm._v(_vm._s(_vm.errors.first("departamento")))
                        ])
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6 col-xs-12" },
                      [
                        _c("vs-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required|min:1|max:50",
                              expression: "'required|min:1|max:50'"
                            }
                          ],
                          staticClass: "w-full",
                          attrs: {
                            type: "email",
                            name: "correo",
                            "icon-pack": "material-icons",
                            icon: "email",
                            "icon-no-border": "",
                            label: "Cargo",
                            value: _vm.actualUserInfo.cargo
                          },
                          on: {
                            input: function($event) {
                              return _vm.updateUserInfoData("cargo", $event)
                            }
                          }
                        }),
                        _c("span", { staticClass: "text-danger text-sm" }, [
                          _vm._v(_vm._s(_vm.errors.first("cargo")))
                        ])
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "row mt-2 text-center" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c(
                          "vx-tooltip",
                          {
                            attrs: {
                              text: "Al hacer click modificara sus datos",
                              position: "top"
                            }
                          },
                          [
                            _c(
                              "vs-button",
                              {
                                staticClass: "mb-2",
                                attrs: {
                                  type: "border",
                                  disabled: !_vm.validarFormularioPerfil
                                },
                                on: { click: _vm.changeProfineInfo }
                              },
                              [_vm._v("Actualizar información ")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ])
              ]
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-3 col-xs-12" },
          [
            _c(
              "b-card",
              { staticClass: "card-top", attrs: { title: "Modificar clave" } },
              [_c("ChangePasswordForm")],
              1
            )
          ],
          1
        )
      ]),
      _c("vs-divider"),
      _c(
        "b-card",
        [
          _c(
            "b-tabs",
            [
              _vm.product !== "aprobacionesApp"
                ? _c(
                    "b-tab",
                    { attrs: { active: "", title: "Suplencias" } },
                    [_c("SubstituteProfileForm")],
                    1
                  )
                : _vm._e(),
              _c(
                "b-tab",
                { attrs: { title: "2FA: Two-Factor Authentication" } },
                [_c("TwoFactorAuthentication")],
                1
              ),
              _vm.company.firmaSimple && _vm.product !== "aprobacionesApp"
                ? _c(
                    "b-tab",
                    { attrs: { title: "Firma simple", lazy: "" } },
                    [
                      _c("FormConfigureSign", {
                        attrs: {
                          user: _vm.currentUser,
                          type: "simple",
                          ambit: "perfil"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.company.firmaAvanzada && _vm.product !== "aprobacionesApp"
                ? _c(
                    "b-tab",
                    { attrs: { title: "Firma avanzada", lazy: "" } },
                    [
                      _c("FormConfigureSign", {
                        attrs: {
                          user: _vm.currentUser,
                          type: "avanzada",
                          ambit: "perfil"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c("vs-divider"),
      _c(
        "vs-prompt",
        {
          attrs: {
            "accept-text": "Cambiar Avatar",
            "cancel-text": "Me arrepentí",
            title: "Nueva imagen",
            "is-valid": _vm.validarImagenVacia,
            active: _vm.promtpAvatar,
            id: "prompt-avatar"
          },
          on: {
            accept: _vm.subirImagen,
            close: _vm.cerrarPromptAvatar,
            "update:active": function($event) {
              _vm.promtpAvatar = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "con-exemple-prompt" },
            [
              _c("cropper", {
                ref: "cropper",
                attrs: {
                  classname: "cropper",
                  src: _vm.imagenPreviaCropper,
                  stencilProps: { previewClassname: "preview" },
                  stencilComponent: _vm.$options.components.CircleStencil
                }
              }),
              _c("div", { staticClass: "button-wrapper" }, [
                _c(
                  "span",
                  {
                    staticClass:
                      "button-imagen vs-button-primary vs-button-border",
                    on: {
                      click: function($event) {
                        return _vm.$refs.imagen.click()
                      }
                    }
                  },
                  [
                    _c("input", {
                      ref: "imagen",
                      attrs: { type: "file", accept: "image/*" },
                      on: {
                        change: function($event) {
                          return _vm.seleccionarImagen($event)
                        }
                      }
                    }),
                    _vm._v(" Seleccionar imagen ")
                  ]
                )
              ])
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }